module.exports = "/packs/shares-4929995-f1de4d06514db16a6b39a14ad730802d.png";